// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__pBM2U","list":"PatternAutocomplete_list__24NnS"};